import { ImageFragment } from '@/lib/fragments'
import FormFragment from '@/lib/fragments/forms/form'

import { graphql } from '@/lib/query'

const SectionContactFragment = graphql(
  /* GraphQL */ `
    fragment SectionContactFragment on SectionContactRecord @_unmask {
      id
      _modelApiKey
      __typename
      title
      contactForm {
        ...FormFragment
      }
      items {
        title
        text
      }
    }
  `,
  [ImageFragment, FormFragment]
)

export default SectionContactFragment
